module.exports = __webpack_public_path__ + "img/gb-eng.e77570a7.svg";